var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.56a9.87 9.87 0 01-2.83.77 4.94 4.94 0 002.17-2.72 10 10 0 01-3.13 1.19 4.93 4.93 0 00-8.52 3.37 5.12 5.12 0 00.13 1.12A14 14 0 011.67 3.15a4.92 4.92 0 001.52 6.57A4.86 4.86 0 011 9.11v.06A4.94 4.94 0 005 14a5 5 0 01-1.29.17 4.73 4.73 0 01-.93-.09 4.93 4.93 0 004.6 3.42 9.9 9.9 0 01-6.12 2.11A9.18 9.18 0 010 19.54a13.92 13.92 0 007.55 2.21 13.92 13.92 0 0014-14v-.63A10.28 10.28 0 0024 4.56"
  })));
}

export default SvgTwitter;